import Page from "../common/page";
import {CustomEventHandler} from "../utils/CustomEventHandler";
import {CUSTOM_SCROLL} from "../common/globalVars";
import {MathUtil} from "../utils/MathUtil";
import ProductSlider from "../lib/slider/product-slider";
// import rewardPopup from "../lib/reward-popup";

export default class PageIndex extends Page {
    setPage() {
        // new rewardPopup(this.data.page.data.member.rwrd_sh);
        // new rewardPopup();

        this.productSlider = new ProductSlider(this.el.querySelector('.sec-6'), this.data.page.data.product_slider);
    }
}
